import React from 'react';
import PropTypes from 'prop-types';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrSunSetupDriverJobPage.less';

const SrSunSetupDriverJobCodeboxLocationPhotos = ({ formikBag, getFormFieldsById }) => {
  return (
    <div styleName="card">
      <span styleName="cardTitle">Location Photos</span>

      <SrBox paddingTop="8px">
        <SrText font="greycliff" fontSize="14px" weight="500" lineHeight="20px">
          Take a photo or multiple photos of the CodeBox location, so renters can easily identify
          its location. These photos will be displayed to the renters during their self-tour.
        </SrText>
      </SrBox>

      <div>
        <SrFormikField
          formField={getFormFieldsById('codeboxLocationPhotos')}
          formikBag={formikBag}
          theme={SR_FIELD_THEME_ADOBE}
        />
      </div>
    </div>
  );
};

SrSunSetupDriverJobCodeboxLocationPhotos.propTypes = {
  formikBag: PropTypes.object.isRequired,
  getFormFieldsById: PropTypes.func.isRequired,
};

SrSunSetupDriverJobCodeboxLocationPhotos.displayName = 'SrSunSetupDriverJobCodeboxLocationPhotos';

export default SrSunSetupDriverJobCodeboxLocationPhotos;
